import type { CapiPlp, GridSize } from 'types/capi/plp';

import usePageData from '~/hooks/usePageData';

import SortOptions from './SortOptions';
import ViewOptions from './ViewOptions';

type Props = {
  gridSize: GridSize;
  setGridSize: React.Dispatch<React.SetStateAction<GridSize>>;
};

export default function SubMenu({ gridSize, setGridSize }: Props) {
  const plp = usePageData<CapiPlp>();

  return (
    <div className="ml-auto flex items-center gap-4 p-0 md:flex-row">
      {plp.sort_options.length > 0 && (
        <SortOptions options={plp.sort_options} />
      )}
      <ViewOptions gridSize={gridSize} setGridSize={setGridSize} />
    </div>
  );
}
